import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPhone, FaPhoneSlash, FaVideo } from 'react-icons/fa';
import { getAvatarUrl } from '../../utils/avatar';

const IncomingCallModal = ({ callInfo, onAccept, onDecline }) => {
  if (!callInfo) return null;

  const { callType, otherUser } = callInfo;
  const isVideo = callType === 'video';

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
        data-testid="incoming-call-modal"
      >
        <motion.div
          initial={{ scale: 0.8, y: 40 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.8, y: 40 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="bg-gray-900 rounded-3xl p-8 w-80 text-center shadow-2xl border border-gray-800"
        >
          {/* Pulsing ring animation */}
          <div className="relative mx-auto w-28 h-28 mb-6">
            <div className="absolute inset-0 rounded-full bg-green-500/20 animate-ping" />
            <div className="absolute inset-2 rounded-full bg-green-500/10 animate-pulse" />
            <img
              src={getAvatarUrl(otherUser?.avatar_url, otherUser?.full_name)}
              alt={otherUser?.full_name}
              className="relative w-28 h-28 rounded-full object-cover border-4 border-green-500/50"
              data-testid="incoming-caller-avatar"
            />
          </div>

          <h2 className="text-white text-xl font-bold mb-1" data-testid="incoming-caller-name">
            {otherUser?.full_name || 'Unknown'}
          </h2>
          <p className="text-gray-400 text-sm mb-1">@{otherUser?.username || 'user'}</p>
          <p className="text-green-400 text-sm font-medium mb-8 animate-pulse" data-testid="incoming-call-type">
            Incoming {isVideo ? 'Video' : 'Voice'} Call...
          </p>

          <div className="flex items-center justify-center gap-8">
            <button
              onClick={onDecline}
              className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center transition-all hover:scale-110 shadow-lg shadow-red-500/30"
              data-testid="decline-call-btn"
            >
              <FaPhoneSlash className="text-white text-xl" />
            </button>
            <button
              onClick={onAccept}
              className="w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center transition-all hover:scale-110 shadow-lg shadow-green-500/30"
              data-testid="accept-call-btn"
            >
              {isVideo ? <FaVideo className="text-white text-xl" /> : <FaPhone className="text-white text-xl" />}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default IncomingCallModal;
